export function removeBreadcrumbs(schema, url) {
  const breadcrumbIds = new Set();

  // STEP 1: remove breadcrumb nodes
  const graphNoBreadcrumbs = schema["@graph"].filter(item => {
    const isBreadcrumb =
      item["@type"] === "BreadcrumbList" ||
      item["@id"]?.toLowerCase().includes("#breadcrumb");

    if (isBreadcrumb && item["@id"]) {
      breadcrumbIds.add(item["@id"]);
    }

    return !isBreadcrumb;
  });

  // STEP 2: update references + modify SearchAction
  const cleanedGraph = graphNoBreadcrumbs.map(item => {
    const newItem = { ...item };

    // Remove embedded breadcrumb references
    if (newItem.breadcrumb && breadcrumbIds.has(newItem.breadcrumb["@id"])) {
      delete newItem.breadcrumb;
    }

    // Remove nested references pointing to removed breadcrumb IDs
    for (const key of Object.keys(newItem)) {
      const value = newItem[key];
      if (typeof value === "object" && value !== null && value["@id"]) {
        if (breadcrumbIds.has(value["@id"])) {
          delete newItem[key];
        }
      }
    }

    // MODIFY SearchAction (inside WebSite object)
    if (Array.isArray(newItem.potentialAction)) {
      newItem.potentialAction = newItem.potentialAction.map(action => {
        if (action["@type"] === "SearchAction" && action.target?.urlTemplate) {
          return {
            ...action,
            target: {
              ...action.target,
              urlTemplate: url+"/search/{search_term_string}/"
            }
          };
        }
        return action;
      });
    }

    return newItem;
  });

  return { ...schema, "@graph": cleanedGraph };
}
